"use strict";var __importDefault=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(exports,"__esModule",{value:!0}),exports.StyledLabel=exports.StyledPasswordInput=exports.StyledAuthInput=void 0;const styled_components_1=__importDefault(require("styled-components"));exports.StyledAuthInput=styled_components_1.default.input`
  box-sizing: border-box;
  border-radius: 6px;
  width: 100%;
  height: 50px;
  font-size: 16px;
  line-height: 22px;
  padding: 13px 20px;
  border: 1px solid #d9d9d9;
`,exports.StyledPasswordInput=styled_components_1.default.input`
  box-sizing: border-box;
  border-radius: 6px;
  width: 100%;
  height: 50px;
  font-size: 16px;
  line-height: 22px;
  padding: 13px 20px;
  border: 1px solid #d9d9d9;
`,exports.StyledLabel=styled_components_1.default.label`
  display: block;
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 6px;
  color: #12102d;
`;